export default __webpack_public_path__ + "static/media/iconCheckDouble.dfaa7a5a.svg";